export default __webpack_public_path__ + "static/media/galleryArrowLeft.140a6684.svg";